export default __webpack_public_path__ + "static/media/fNeutral26.5b4b693e.png";